<template>
  <div>
    <div class="manage-answers-page">
      <div class="manage-answers-page__header -mt-5 u-margin-bottom-small">
        <div class="row u-margin-bottom-medium">
          <div class="w-50">
            <div class="form-input">
              <label for="select_question_type" class="control-label">{{ $t('Choose Question Type') }}</label>
              <multiselect
                v-model="selectedQuestionType"
                :options="questionTypes"
                @select="selectQuestionType($event)"
                id="select_question_type"
                :loading="loading"
                track-by="id"
                label="name"
                :multiple="false"
                :close-on-select="true"
                :show-labels="false"
              >
              </multiselect>
            </div>
          </div>
        </div>
        <div class="row justify-content-between">
          <div v-if="canCreateQuestions()" class="col-1-of-4">
            <router-link :to="{ name: 'Create Question' }">
              <p-button type="warning" outline> Create Question </p-button>
            </router-link>
          </div>
          <div class="col-2-of-4">
            <SmallSearch @search="search = $event" />
          </div>
          <div class="col-1-of-4">
            <p-button icon outline @click.native.prevent="openFilters = true">
              <i class="fas fa-filter" />
            </p-button>
          </div>
        </div>
        <div class="row">
          <div class="col-1-of-2">
            <div class="manage-company-answers__header-selectedFilters">
              <div v-for="(selectedFilter, index) in selectedFilters" v-bind:key="index">
                <span class="manage-company-answers__header-selectedFilter">{{ selectedFilter.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="manage-answers-page__body">
        <QuestionsList
          :questions="questions"
          :search="search"
          :loading="loadingQuestions"
          :filters="selectedFilters"
          :question-edit="true"
          :question-type="selectedQuestionType"
          questionLayout="Edit"
        />
      </div>
      <div class="manage-answers-page__footer"></div>
    </div>

    <ModalTemplate
      component-name="FiltersModal"
      :data="{
        header: 'Set Filters',
        checkedFilters: selectedFilters,
        filtersOptions: {
          Categories: categories,
          Subcategories: subcategories,
        },
      }"
      :clicked="openFilters"
      @update:field="openFilters = false"
      @submit="setFilters($event)"
    >
    </ModalTemplate>
  </div>
</template>

<script>
import QuestionTypeController from '@/controllers/QuestionType/QuestionTypeController';
import ModalTemplate from '@/components/modals/ModalTemplate';
import SmallSearch from '@/components/search/SmallSearch';
import QuestionsList from '@/components/Questions/QuestionsList';
import QuestionHasTypeController from '@/controllers/QuestionHasType/QuestionHasTypeController';
import CategoryController from '@/controllers/Category/CategoryController';
import SubcategoryController from '@/controllers/Category/SubcategoryController';
import checkIfCanCreateQuestions from '@/router/scopes/manage_questions/CheckIfCanCreateQuestions';

export default {
  name: 'ManageQuestions',
  components: { QuestionsList, SmallSearch, ModalTemplate },
  data() {
    return {
      loading: true,
      loadingQuestions: false,
      questionTypes: [],
      selectedQuestionType: null,
      selectedFilters: [],
      questions: {},
      search: '',
      openNewQuestionModal: false,
      openFilters: false,
      categories: [],
      subcategories: [],
    };
  },
  async beforeMount() {
    this.setLoading();
    await this.getQuestionTypes();
    await this.setCategories();
    await this.setSubcategories();
    this.resetLoading();
  },
  methods: {
    async getQuestionTypes() {
      this.questionTypes = await QuestionTypeController.index();
    },
    async addQuestion() {},
    setLoading() {
      this.loading = true;
    },
    resetLoading() {
      this.loading = false;
    },
    async selectQuestionType(questionType) {
      this.loadingQuestions = true;
      await this.getQuestionsOfType(questionType);
      this.loadingQuestions = false;
    },
    async getQuestionsOfType(questionType) {
      return (this.questions = await QuestionHasTypeController.show(questionType.id));
    },
    setFilters(filters) {
      this.selectedFilters = filters;
    },
    async setCategories() {
      this.categories = await CategoryController.index();
    },
    async setSubcategories() {
      this.subcategories = await SubcategoryController.index();
    },
    canCreateQuestions() {
      return checkIfCanCreateQuestions();
    },
  },
};
</script>

<style scoped></style>
